module.exports = __webpack_public_path__ + "img/main_ranking_3rd.6876cd5.png";